import { waterfallHybridRoutes } from "features/waterfall/hybrid/HybridRoutes";
import { waterfallReviewRoutes } from "features/waterfall/review/WaterfallReviewRoutes";
import { RouteObject } from "react-router-dom";

export const waterfallRoutes: RouteObject = {
  id: "capitalActivityCapitalActivityEventWaterfall",
  path: "waterfall",
  children: [waterfallReviewRoutes, waterfallHybridRoutes],
};
